module.exports = __webpack_public_path__ + "static/water_glacier1-f5c7c42023b08b8597b686eca32d11dd.jpg";